import { useLingui } from "@lingui/react/macro";

type CappedListOptions = {
  cap?: number;
  fallback?: string;
};

export function useCappedList() {
  const { t } = useLingui();

  return function formatCappedList(
    items: string[],
    { cap = 3, fallback = "-" }: CappedListOptions = {}
  ): string {
    if (!items.length) {
      return fallback;
    }

    const visible = items.slice(0, cap);
    const rest = items.length - cap;

    if (rest <= 0) {
      return visible.join(", ");
    }

    return `${visible.join(", ")} ${t`+${rest} till`}`;
  };
}
